
<template>
  <div class="content">
        <iframe :src="srcs" class="iframe-sty" :style="height"></iframe>
  </div>
</template>

<script> 
export default { 
  data() { 
    return { 
      srcs:'',
      winHeight: window.innerHeight,
      height: {
        height: '',
      },
    }; 
  },
  created() {  

  },
  mounted(){     
    window.onresize = () => { 
    return (() => { 
    this.winHeight = window.innerHeight 
        })
    } 
    this.height.height=this.winHeight-124+'px';  
  }, 
  methods: { 

  }
}
</script>
<style scoped> 
</style>